import { React } from 'react'
import { Dropdown, Space, Select } from 'antd'
import { confirmBase, ExpiresAt } from 'utils/ui'
import moment from 'moment'
import dayjs from 'dayjs'
import i18n from 'i18n'
import classNames from 'classnames'

import { timeFormat } from 'utils'
import { isGlobal } from 'conf'
import { SRC_TYPE } from 'pages/records/components/helper'
import DateInput from 'components/Date/CalendarSelector'
import TimeSelector from 'components/Date/TimeSelector'
import groupBlackSVG from '@/assets/images/group-black-24.svg'
import arrowIcon from '@/assets/images/chevron-down-24.svg'

import styles0 from './style.module.scss'

const temp = {}
const timeValueCache = {} // 각 record의 시간 값을 저장

const disableInfo = {
  curdate: null,
  hour: -1,
  minute: -1,
}

const durations = {
  2: { amount: 1, unit: 'hour' },
  3: { amount: 1, unit: 'day' },
  4: { amount: 7, unit: 'days' },
  5: { amount: 1, unit: 'month' },
  6: { amount: 1, unit: 'year' },
}

const VIEW_ONLY = 'user.authority.viewOnly'
const CAN_EDIT = 'user.authority.canEdit'
const OWNER = 'member.column.owner'

const AUTHORITY_MAP = {
  1: VIEW_ONLY,
  7: CAN_EDIT,
  15: OWNER,
}

const getTableInfo = (styles, shareList, setShareList) => {
  const onRow = (record /* , rowIndex */) => {
    return {
      onClick: (e) => {
        console.log(' - click ', e, record)
        const checkTrEleme = e.target.closest('.ant-table-row:not(.checkDisbaled)')

        if (checkTrEleme) {
          const tdElements = Array.from(checkTrEleme.querySelectorAll('td.ant-table-cell')).slice(
            0,
            3,
          )

          const checkElem = checkTrEleme.querySelector('input[type="checkbox"]')

          if (checkElem && tdElements.some((td) => td.contains(e.target))) {
            checkElem.click()
          }
        }
      },
    }
  }

  const columns = [
    {
      dataIndex: 'avatarUrl',
      key: 'avatar',
      width: 48,
      render: (_, record) => {
        console.log('record record.avatarUrl- ', record)
        const avatarUrl = () =>
          isGlobal() ? (record.originData?.avatar_url ?? record.avatarUrl) : record.avatarUrl

        if (record.type === 'group') {
          return (
            <span className={classNames(styles.imageWrapper)}>
              <img
                src={groupBlackSVG}
                alt={record.name}
                className={classNames(styles.groupImage)}
              />
            </span>
          )
        }
        return (
          <img src={avatarUrl()} alt={record.name} className={classNames(styles.personImage)} />
        )
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        const { name, email, expiredAt, newExpiredAt } = record

        const attrs = {
          styles2: styles,
          expiredAt,
          newExpiredAt,
          email,
          expiredBoolean: record.expired,
        }

        return (
          <div className={classNames(styles.info)}>
            <div className={classNames(styles.div)}>
              <span className={classNames(styles.name)}>{name}</span>
              <span className={classNames(styles.expired)}>
                <ExpiresAt {...attrs} type="name" />
              </span>
            </div>
            <span className={classNames(styles.email)}>
              <ExpiresAt {...attrs} type="table" />
            </span>
          </div>
        )
      },
    },
    // {
    //   dataIndex: 'name',
    //   key: 'name',
    //   render: (_, record) => {
    //     const { name, permission } = record
    //     console.log('record record.name- ', name)

    //     const defaultText = (text) => {
    //       const key = text != null ? authorityMap[text] : VIEW_ONLY
    //       return i18n.t(key || VIEW_ONLY)
    //     }

    //     const items = [
    //       {
    //         key: 1,
    //         label: i18n.t(VIEW_ONLY),
    //         onClick: ({ key }) => {
    //           console.log('Authority changed:', key)
    //           // 권한 변경 로직 추가 가능
    //         },
    //       },
    //       {
    //         key: 7,
    //         label: i18n.t(CAN_EDIT),
    //         onClick: ({ key }) => {
    //           console.log('Authority changed:', key)
    //           // 권한 변경 로직 추가 가능
    //         },
    //       },
    //       {
    //         key: 15,
    //         label: i18n.t(OWNER),
    //         onClick: ({ key }) => {
    //           console.log('Authority changed:', key)
    //           // 권한 변경 로직 추가 가능
    //         },
    //       },
    //     ]

    //     const authorityDropdownAttrs = {
    //       menu: {
    //         items,
    //         selectedKeys: permission != null ? [permission.toString()] : ['1'],
    //         selectable: true,
    //       },
    //       trigger: ['click'],
    //       overlayClassName: classNames('contextMenu', styles0.permissionDropdownOverlay),
    //       className: classNames(styles.permissionDropdown),
    //     }

    //     return (
    //       <div className={classNames(styles.info)}>
    //         <div className={classNames(styles.div)}>
    //           <Dropdown {...authorityDropdownAttrs}>
    //             <Space>
    //               {defaultText(permission)}
    //               <img src={arrowIcon} alt="icons" style={{ width: '24px', height: '24px' }} />
    //             </Space>
    //           </Dropdown>
    //         </div>
    //       </div>
    //     )
    //   },
    // },
    {
      dataIndex: 'type',
      key: 'action',
      className: classNames(styles.type),
      render: (_, record) => {
        const { sourceType, permission: permissionText, expiredAt, expired } = record

        let retElem = null
        let selectOptions = []

        selectOptions = [
          ...(expiredAt !== 0
            ? [
                {
                  value: 0,
                  label: i18n.t('record.select.expiredDate.noExpiration'),
                },
              ]
            : []),
          ...(expiredAt != null && expired === false
            ? [
                {
                  value: 1,
                  label: (
                    <span>
                      {i18n.t('record.label.expiresDate', {
                        date: timeFormat(expiredAt, 'YYYY/MM/DD HH:mm'),
                      })}
                    </span>
                  ),
                },
              ]
            : []),
        ]

        // expiration
        selectOptions = [
          ...selectOptions,
          {
            value: 2,
            label: i18n.t('record.select.expiredDate.1hour'),
          },
          {
            value: 3,
            label: i18n.t('record.select.expiredDate.1day'),
          },
          {
            value: 4,
            label: i18n.t('record.select.expiredDate.1week'),
          },
          {
            value: 5,
            label: i18n.t('record.select.expiredDate.1month'),
          },
          {
            value: 6,
            label: i18n.t('record.select.expiredDate.1year'),
          },
          {
            value: 7,
            label: i18n.t('record.select.expiredDate.custom'),
          },
        ]

        const customExpirationTime = (value) => {
          if (value === 0) return 0
          if (value === 1) return expiredAt

          const today = moment()

          const duration = durations[value]
          if (duration) {
            return today.add(duration.amount, duration.unit).toISOString()
          }

          return value
        }

        const customExpiration = () => {
          const recordKey = record.id || record.email || 'default'
          const now = moment()
          const interval = 30

          // 30분 단위로 올림하는 함수
          const roundUpToInterval = (m) => {
            const minutes = m.minutes()
            const remainder = minutes % interval
            if (remainder === 0) {
              return m.clone()
            }
            return m
              .clone()
              .add(interval - remainder, 'minutes')
              .seconds(0)
          }

          // 초기 시간 값 계산
          let initialTime = timeFormat(record.newExpiredAt) || timeFormat(record.expiredAt) || null

          // initialTime이 과거 시간이면 현재 시간으로 변경
          if (initialTime == null || moment(initialTime).isBefore(now)) {
            initialTime = roundUpToInterval(now).toISOString()
          }

          const initialTimeStr = moment(initialTime).format('YYYY-MM-DD HH:mm:ss')
          const timeObj = dayjs(initialTimeStr)
          const dateValue = timeObj.toDate()

          // 캐시에 시간 값 설정 (initialTime이 이미 유효한 시간으로 설정됨)
          timeValueCache[recordKey] = timeObj.format('HH:mm')

          const timeValue = timeValueCache[recordKey]
          disableInfo.curdate = timeObj
          console.log(' --- initialTime --- ', initialTime)

          return (
            <div className={classNames(styles.DatePicker)}>
              <DateInput
                value={dateValue}
                onChange={(date) => {
                  if (date != null) {
                    disableInfo.curdate = dayjs(date)
                    // 캐시된 시간 값을 사용하여 새로운 날짜에 적용
                    let cachedTime = timeValueCache[recordKey] || timeObj.format('HH:mm')

                    // 날짜가 오늘인지 확인
                    const selectedDate = moment(date)
                    const today = moment()
                    const isToday = selectedDate.isSame(today, 'day')

                    if (isToday) {
                      // 현재 시간 가져오기
                      const currentTimeStr = now.format('HH:mm')
                      const [currentHour, currentMinute] = currentTimeStr.split(':').map(Number)
                      const [cachedHour, cachedMinute] = cachedTime.split(':').map(Number)

                      // 캐시된 시간이 현재 시간보다 이전인지 확인
                      const cachedTimeMinutes = cachedHour * 60 + cachedMinute
                      const currentTimeMinutes = currentHour * 60 + currentMinute

                      if (cachedTimeMinutes < currentTimeMinutes) {
                        // 현재 시간에서 5분 추가
                        const newTime = now.add(5, 'minutes')
                        cachedTime = newTime.format('HH:mm')
                        timeValueCache[recordKey] = cachedTime
                      }
                    }

                    const [hours, minutes] = cachedTime.split(':')
                    const time = moment(date)
                    time.hour(parseInt(hours, 10))
                    time.minute(parseInt(minutes, 10))
                    time.second(0)
                    const newExpiredAt = time.toISOString()
                    handleExpiredChange(true, newExpiredAt)
                  }
                }}
                placeholder="YYYY-MM-DD"
              />
              <TimeSelector
                value={timeValue}
                selectedDate={record.newExpiredAt || record.expiredAt || dateValue}
                onChange={(selectedTimeStr) => {
                  if (selectedTimeStr != null && selectedTimeStr !== '') {
                    // 시간 값 변경 시 캐시 업데이트
                    timeValueCache[recordKey] = selectedTimeStr

                    const curTime =
                      timeFormat(record.newExpiredAt) ||
                      timeFormat(record.expiredAt) ||
                      timeFormat(new Date())
                    const time = moment(curTime)
                    const [hours, minutes] = selectedTimeStr.split(':')
                    time.hour(parseInt(hours, 10))
                    time.minute(parseInt(minutes, 10))
                    time.second(0)
                    const newExpiredAt = time.toISOString()
                    handleExpiredChange(true, newExpiredAt)
                  }
                }}
                placeholder="HH:mm"
              />
            </div>
          )
        }

        const expirationSelect = (isCustom) => (
          <div className={styles.expirationContent}>
            <Select {...expirationSelectOptions} />
            {isCustom === true ? customExpiration() : null}
          </div>
        )

        const handleExpiredChange = (isCustom, value) => {
          if (shareList != null) {
            const changedUser = shareList.find((item) => {
              if (item.email == null) {
                return item.id === record.id
              }
              return item.email === record.email
            })

            if (changedUser != null) {
              changedUser.newExpiredAt = customExpirationTime(value)
              if (temp.modalObj != null) {
                temp.modalObj.update({
                  title: i18n.t('record.title.accessExpiration'),
                  content: expirationSelect(isCustom, changedUser.newExpiredAt),
                })
              }
            }
          }
        }

        const expirationSelectOptions = {
          width: '100%',
          className: classNames(styles.expirationSelect),
          suffixIcon: <img src={arrowIcon} alt="icons" style={{ width: '24px', height: '24px' }} />,
          options: selectOptions,
          // open: true,
          listHeight: 400,
          popupClassName: classNames('expirationSelectOverlay'),
          defaultValue:
            record.newExpiredAt === 0 || (record.newExpiredAt == null && expiredAt == null)
              ? i18n.t('record.select.expiredDate.noExpiration')
              : `${i18n.t('record.label.expiresDate', { date: timeFormat(record.newExpiredAt || expiredAt, 'YYYY/MM/DD HH:mm') })}`,
          onSelect: (value) => {
            // 7이면 open
            if (value === 7) {
              const initialTime = record.newExpiredAt || record.expiredAt
              handleExpiredChange(true, initialTime)

              // 7이 아니면 close
            } else {
              handleExpiredChange(false, value)
            }
          },
        }

        // permission
        const defaultText = (text) => {
          const key = text != null ? AUTHORITY_MAP[text] : VIEW_ONLY

          /* i18next-extract-disable-next-line */
          return i18n.t(key || VIEW_ONLY)
        }

        const items = [
          ...(record.expired && record.newExpiredAt == null
            ? []
            : [
                {
                  key: 1,
                  label: i18n.t(VIEW_ONLY),
                  onClick: ({ key }) => {
                    handleChange(key)
                  },
                },
                {
                  key: 7,
                  label: i18n.t(CAN_EDIT),
                  onClick: ({ key }) => {
                    handleChange(key)
                  },
                },
                {
                  type: 'divider',
                },
              ]),

          {
            key: 20,
            label: i18n.t('record.title.accessExpiration'),
            onClick: () => {
              temp.modalObj = confirmBase({
                title: i18n.t('record.title.accessExpiration'),
                content: expirationSelect(false, expiredAt),
                okText: i18n.t('common.button.save'),
                onOk: () => {
                  setShareList([...shareList])
                },
                maskTransitionName: 'expirationModal',
                afterClose: () => {
                  temp.modalObj = null
                },
              })
              // setModalObj(obj)
            },
          },
        ]

        const handleChange = (value) => {
          if (shareList != null) {
            const updatedList = shareList.map((item) => {
              if (item.id === record.id) {
                return {
                  ...item,
                  permission: Number(value),
                }
              }
              return item
            })

            setShareList(updatedList)
          }
        }

        const permissionDropdownAttrs = {
          menu: {
            items,
            selectedKeys: permissionText != null ? [permissionText.toString()] : [],
            selectable: true,
          },
          trigger: ['click'],
          overlayClassName: classNames('contextMenu', styles0.permissionDropdownOverlay),
          className: classNames(styles.permissionDropdown),
        }

        if (sourceType === SRC_TYPE.OWNER || sourceType === SRC_TYPE.GROUP_OWNER) {
          retElem = <p style={{ paddingRight: '24px' }}>{i18n.t('user.authority.owner')}</p>
        } else if (
          sourceType === SRC_TYPE.ORGCHART_USER ||
          sourceType === SRC_TYPE.GROUP_ITEM ||
          sourceType === SRC_TYPE.SHARED_USER ||
          sourceType === SRC_TYPE.SHARED_GROUP ||
          sourceType === SRC_TYPE.GLOBAL_USER
          // sourceType === SRC_TYPE.GROUP_USER
        ) {
          retElem = (
            <Dropdown {...permissionDropdownAttrs}>
              <Space>
                {defaultText(permissionText)}
                <img src={arrowIcon} alt="icons" style={{ width: '24px', height: '24px' }} />
              </Space>
            </Dropdown>
          )
        } else {
          return null
        }
        return retElem
      },
    },
  ]

  return { columns, onRow }
}

export default getTableInfo
